import { useQuery } from "react-query";
import { IPaginatedResponse } from "../../../../interfaces/response";
import { getData } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";

export interface IAggregatorRep {
  first_name: string;
  last_name: string;
  personal_email: string;
  personal_phone: string;
  title: string;
}

export interface ICorporateCustomer {
  aggregator_id: number;
  customer_id: number;
  biz_name: string;
  biz_registration_number: string;
  biz_registration_type: number;
  biz_email: string;
  biz_phone: string;
  biz_Address: string;
  biz_category: string;
  biz_description: string;
  is_active: boolean;
  sector_id: number;
  sector_name: string;
  photo: string;
  pub_date: string;
  modified_date: string;
  xaggregator_domain: string;
  short_name: string;
  state_name: string;
  city: string;
  aggregator_rep: IAggregatorRep;
  aggregator_photo_url: string;
  country: string;
  business_overview: string;
  business_type: string;
  business_type_id: number;
  onboarding_status: string;
  business_subtype: string;
  business_subtype_id: number;
  position_id: number;
  position: string;
}

export interface ICorporateCustomersParams {
  page?: number;
  pageSize?: number;
  sourceAppId?: number;
  onboardingStartDate?: string;
  onboardingEndDate?: string;
  onboardingStatus?: string;
  searchValue?: string;
}

const getCorporateCustomers = async (
  params: ICorporateCustomersParams
): Promise<IPaginatedResponse<ICorporateCustomer[]>> => {
  const queryParams = new URLSearchParams();

  if (params.page) queryParams.append("Page", params.page.toString());
  if (params.pageSize)
    queryParams.append("PageSize", params.pageSize.toString());
  if (params.sourceAppId)
    queryParams.append("SourceAppId", params.sourceAppId.toString());
  if (params.onboardingStartDate)
    queryParams.append("OnboardingStartDate", params.onboardingStartDate);
  if (params.onboardingEndDate)
    queryParams.append("OnboardingEndDate", params.onboardingEndDate);
  if (params.onboardingStatus)
    queryParams.append("OnboardingStatus", params.onboardingStatus);
  if (params.searchValue) queryParams.append("SearchValue", params.searchValue);

  const endpoint = `${ajaxEndpoints.OFFLINE_CORPORATE_CUSTOMERS}?${queryParams.toString()}`;
  const response = await getData(endpoint);
  return response.data;
};

interface UseCorporateCustomersProps {
  params: ICorporateCustomersParams;
}

export function useGetCorporateCustomers({
  params,
}: UseCorporateCustomersProps) {
  return useQuery<IPaginatedResponse<ICorporateCustomer[]>>(
    ["corporateCustomers", params],
    () => getCorporateCustomers(params),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );
}
